export interface IFilterParams {
  start?: number;
  end?: number;
  audienceLists?: string[];
  language?: string;
  page?: number;
  textSearch?: string;
  sortBy?: string;
  sortOrder?: number;
  channel?: number;
  allowMultiAudienceLists?: boolean;
}

const filterParams = (filters?: IFilterParams, additionalParams = {}) => {
  const params = new URLSearchParams();

  const { audienceLists, allowMultiAudienceLists, ...rest } = filters || {};

  if (audienceLists?.length) {
    if (allowMultiAudienceLists) {
      audienceLists?.forEach((list) => params.append('audienceLists', list));
    } else {
      params.append('audienceLists', audienceLists[0]);
    }
  }

  Object.entries(rest).forEach((entry) => {
    const key = entry[0];
    const value = entry[1];

    if (value) {
      if (typeof value === 'string') {
        params.set(key, value);
      } else if (!isNaN(value)) {
        params.set(key, value.valueOf().toString());
      } else {
        params.set(key, value.toString());
      }
    }
  });

  for (const [key, value] of Object.entries(additionalParams)) {
    params.set(key, String(value));
  }

  const urlParams = params.toString();

  return urlParams;
};

export default filterParams;
